import { render, staticRenderFns } from "./OwnersTransactionsAceptance.vue?vue&type=template&id=3006dddc&scoped=true&"
import script from "./OwnersTransactionsAceptance.vue?vue&type=script&lang=js&"
export * from "./OwnersTransactionsAceptance.vue?vue&type=script&lang=js&"
import style0 from "./OwnersTransactionsAceptance.vue?vue&type=style&index=0&id=3006dddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006dddc",
  null
  
)

export default component.exports